module.exports = __webpack_public_path__ + "img/v.3b5562d6.svg";